var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 16,
    fill: "#F4413D",
    fillOpacity: 0.08
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.6733 30.9414C38.5813 30.9414 35.2515 34.2713 35.2515 38.3633C35.2515 39.9257 35.733 41.4209 36.6565 42.7037L41.8253 49.6724C42.0252 49.9395 42.3399 50.0969 42.6733 50.0969H42.6744C43.0078 50.0969 43.3226 49.9385 43.5224 49.6713L48.9004 42.3972C49.6821 41.1962 50.0952 39.8014 50.0952 38.3633C50.0952 34.2713 46.7653 30.9414 42.6733 30.9414ZM42.6733 41.5441C40.9194 41.5441 39.4925 40.1172 39.4925 38.3633C39.4925 36.6093 40.9194 35.1825 42.6733 35.1825C44.4273 35.1825 45.8541 36.6093 45.8541 38.3633C45.8541 40.1172 44.4273 41.5441 42.6733 41.5441Z",
    fill: "#F4413D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5107 14.0571C15.1825 13.8614 14.7756 13.8552 14.4422 14.0437C14.1098 14.2321 13.9048 14.5841 13.9048 14.9662V36.2422C13.9048 36.615 14.1005 36.9598 14.4194 37.1513L24.5781 43.2041V19.4554L15.5107 14.0571Z",
    fill: "#F4413D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4602 20.4204L37.3721 14.3672V30.4374C38.8897 29.4192 40.7125 28.822 42.6734 28.822C44.6343 28.822 46.4571 29.4192 47.9747 30.4374V21.3295C47.9747 20.9568 47.779 20.612 47.4602 20.4204Z",
    fill: "#F4413D"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2516 14.3672L26.6987 19.4569V43.2058L33.2075 39.343C33.174 39.018 33.131 38.6945 33.131 38.3644C33.131 36.1155 33.9454 34.0733 35.2516 32.4406V14.3672Z",
    fill: "#F4413D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMap);
export default __webpack_public_path__ + "static/media/map.2a30bbfb5e01a6ebbeefae121f30a772.svg";
export { ForwardRef as ReactComponent };